import React from 'react';
import { Button, Tooltip } from 'antd';
import { FunctionOutlined, FieldStringOutlined } from '@ant-design/icons';
import { createUseStyles } from 'react-jss';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles({
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '0',
        padding: '8px',
        background: '#fafafa',
        border: '1px solid #d9d9d9',
        borderBottom: 'none',
        borderRadius: '4px 4px 0 0',
    },
    button: {
        fontSize: '12px',
        height: '28px',
        padding: '0 20px',
    },
});

interface EditorToolbarProps {
    onInsertFunction: () => void;
    onInsertField: () => void;
    disabled?: boolean;
}

export const EditorToolbar: React.FC<EditorToolbarProps> = ({
    onInsertFunction,
    onInsertField,
    disabled = false,
}: EditorToolbarProps) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div className={classes.toolbar}>
            <Tooltip title={t('Insert Field Reference')}>
                <Button
                    className={classes.button}
                    icon={<FieldStringOutlined />}
                    onClick={onInsertField}
                    disabled={disabled}
                >
                    {'[[Field]]'}
                </Button>
            </Tooltip>

            <Tooltip title={t('Insert Calculation Function')}>
                <Button
                    className={classes.button}
                    icon={<FunctionOutlined />}
                    onClick={onInsertFunction}
                    disabled={disabled}
                >
                    {t('BI_Functions')}
                </Button>
            </Tooltip>
        </div>
    );
};

export default EditorToolbar;

